export const ElemSchema = () => ({
  title: "Element",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image','alt', 'titel', 'text', 'link'],
    },
  ],

  properties: {
    titel: {
      title: 'Titel',
      type: 'string',
    },
    image: {
      title: 'Icon',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    alt: {
      title: 'Image Alt Text',
      type: 'string',
    },
    link: {
      title: 'Link',
      type: 'string',
    },
    text: {
      title: 'Text',
      type: 'string',
      widget: 'textarea',

    },
  },
  required: [],
});

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'content',
      title: "Zellen hinzu",
      fields: ['elems'],
    },
  ],

  properties: {
    elems: {
      title: "Elements",
      schema: ElemSchema(intl),
      widget: 'object_list',
    },
  },
  required: [],
});
